import { getCookie } from '@square/dashboard-utilities/utils/cookies';
export function getCsrfToken() {
  return getCookie('_js_csrf') || document.querySelector('meta[name=csrf-token]')?.getAttribute?.('content') || '';
}